import isFunction from 'lodash/isFunction';
import upperFirst from 'lodash/upperFirst';
import React, { Component } from 'react';
import Data from '../../data';
import { Capability } from '../../data/account';
import {
	CustomsDeclarationsOptions,
	IncludeItnNumberOptions,
	NonDeliveryOptions,
	PackageContentsOptions,
} from '../../data/settings';
import Modal from '../../modal';
import ShipStationModule from '../../shipstation';
import UI from '../../ui';
import Session from '../../utils/Session';
import Util from '../Util';
import OrdersMarketingView from './OrdersMarketingView.component';
import OrdersUpgradeView from './OrdersUpgradeView.component';

const { ModalContext } = Modal;
const { ShipStation } = ShipStationModule;
const { Countries } = Data;
const { WrappedButton, WrappedDropdown, WrappedInputText, WrappedInputNumber } =
	UI;

export default class InternationalView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			customsContentType: '',
			customsNonDelivery: '',
			createCustomsItems: '',
			iTNTaxId: '', // this field will always be blank on mount
			iTNSetting: '',
			customsItemDescription: '',
			customsItemQty: 0,
			customsItemValue: 0,
			customsItemCountry: 'US',
			customsItemHarmonization: '',
		};
	}

	async componentDidMount() {
		await ShipStation.getLookup();

		const {
			CustomsContentType = '',
			CustomsNonDelivery = '',
			CreateCustomsItems = '',
			ITNSetting = '',
			CustomsItemDescription = '',
			CustomsItemQty = 0,
			CustomsItemValue = 0,
			CustomsItemCountry = 'US',
			CustomsItemHarmonization = '',
		} = ShipStation.getSettings();

		this.setState({
			customsContentType: CustomsContentType,
			customsNonDelivery: CustomsNonDelivery,
			createCustomsItems: CreateCustomsItems,
			iTNSetting: ITNSetting,
			customsItemDescription: CustomsItemDescription,
			customsItemQty: Number(CustomsItemQty),
			customsItemValue: Number(CustomsItemValue),
			customsItemCountry: CustomsItemCountry,
			customsItemHarmonization: CustomsItemHarmonization,
		});
	}

	buildParams = newValue => {
		const newPreferences = { ...this.state, ...newValue };
		const { createCustomsItems } = newPreferences;
		const shouldSaveCustomsItems = createCustomsItems === 'static';
		const params = [];

		Object.entries(newPreferences).forEach(([key, value]) => {
			const isCustomsItem = key.startsWith('customsItem');

			// only save customs items if createCustomsItems is static
			if (!isCustomsItem || (shouldSaveCustomsItems && isCustomsItem)) {
				params.push(`${upperFirst(key)}=${value}`);
			}
		});

		return params.join('&');
	};

	onChangeDropdown = ({ target: { name }, value }) => {
		const { showError } = this.context;
		const newPreference = {
			[name]: value,
		};

		this.setState(newPreference);

		Util.saveOrdersPreferences(this.buildParams(newPreference), showError);
	};

	onChangeField = ({ target: { name, value } }) => {
		const { showError } = this.context;
		const newPreference = {
			[name]: value,
		};

		this.setState(newPreference);

		Util.saveOrdersPreferences(this.buildParams(newPreference), showError);
	};

	onChangeInputNumber = ({ target: { name, value = 0 } }) => {
		const { showError } = this.context;
		const newPreference = {
			[name]: value,
		};

		this.setState(newPreference);

		Util.saveOrdersPreferences(this.buildParams(newPreference), showError);
	};

	onClickDone = () => {
		const { completionCallback } = this.props;

		if (isFunction(completionCallback)) {
			completionCallback({ close: true });
		}
	};

	renderAdditionalFields = () => {
		const {
			customsItemDescription,
			customsItemQty,
			customsItemValue,
			customsItemCountry,
			customsItemHarmonization,
		} = this.state;

		return (
			<>
				<div className="p-col-9 p-offset-2">
					<div
						className="settings-label"
						data-qa="settingsInternational-description-text"
						{...{ dataqa: 'settingsInternational-description-text' }}
					>
						Description:
					</div>
					<WrappedInputText
						name="customsItemDescription"
						onChange={this.onChangeField}
						value={customsItemDescription}
						dataqa="settingsInternational-description"
					/>
				</div>
				<div className="p-col-9 p-offset-2">
					<div
						className="settings-label"
						data-qa="settingsInternational-qty-text"
						{...{ dataqa: 'settingsInternational-qty-text' }}
					>
						Qty:
					</div>
					<WrappedInputNumber
						name="customsItemQty"
						value={customsItemQty}
						min={0}
						onChange={this.onChangeInputNumber}
						dataqa="settingsInternational-qty"
					/>
				</div>
				<div className="p-col-9 p-offset-2">
					<div
						className="settings-label"
						data-qa="settingsInternational-unitPrice-text"
						{...{ dataqa: 'settingsInternational-unitPrice-text' }}
					>
						Unit Price ($):
					</div>
					<WrappedInputNumber
						name="customsItemValue"
						value={customsItemValue}
						min={0}
						onChange={this.onChangeInputNumber}
						mode="decimal"
						minFractionDigits={2}
						maxFractionDigits={2}
						dataqa="settingsInternational-unitPrice"
					/>
				</div>
				<div className="p-col-9 p-offset-2">
					<div
						className="settings-label"
						data-qa="settingsInternational-madeIn-text"
						{...{ dataqa: 'settingsInternational-madeIn-text' }}
					>
						Made In:
					</div>
					<WrappedDropdown
						name="customsItemCountry"
						value={customsItemCountry}
						onChange={this.onChangeDropdown}
						options={Countries}
						optionLabel="countryName"
						optionValue="countryCode"
						dataqa="settingsInternational-madeIn"
					/>
				</div>
				<div className="p-col-9 p-offset-2">
					<div
						className="settings-label"
						data-qa="settingsInternational-hsTariff-text"
						{...{ dataqa: 'settingsInternational-hsTariff-text' }}
					>
						HS Tariff:
					</div>
					<WrappedInputText
						name="customsItemHarmonization"
						onChange={this.onChangeField}
						value={customsItemHarmonization}
						dataqa="settingsInternational-hsTariff"
					/>
				</div>
			</>
		);
	};

	render() {
		const {
			customsContentType,
			customsNonDelivery,
			createCustomsItems,
			iTNTaxId,
			iTNSetting,
		} = this.state;

		const displayAdditionalFields = createCustomsItems === 'static';

		if (!Session.hasCapability(Capability.CanUseOrders)) {
			return <OrdersUpgradeView />;
		}

		// display Orders Marketing if user is not connected to ShipStation
		if (!ShipStation.isShipStationConnected()) {
			return <OrdersMarketingView />;
		}

		return (
			<div className="settings-orders-international-view">
				<div className="settings-body">
					<div
						className="settings-content-header"
						data-qa="settingsInternational-defaultCustoms-header"
						{...{ dataqa: 'settingsInternational-defaultCustoms-header' }}
					>
						<p>Default Customs Information</p>
						<hr />
					</div>
					<div className="p-grid p-dir-col">
						<div className="p-col-12">
							<p
								data-qa="settingsInternational-note-text"
								{...{ dataqa: 'settingsInternational-note-text' }}
							>
								Automatically assign default customs form information for every
								order that imports with an international destination. You can
								always edit individual orders to override these settings.
							</p>
						</div>
						<div className="p-col-10 p-offset-1">
							<div
								className="settings-label"
								data-qa="settingsInternational-packageContents-text"
								{...{ dataqa: 'settingsInternational-packageContents-text' }}
							>
								Package Contents:
							</div>
							<WrappedDropdown
								name="customsContentType"
								value={customsContentType}
								onChange={this.onChangeDropdown}
								options={PackageContentsOptions}
								optionLabel="label"
								optionValue="value"
								dataqa="settingsInternational-packageContents"
							/>
						</div>
						<div className="p-col-10 p-offset-1">
							<div
								className="settings-label"
								data-qa="settingsInternational-nonDeliveryOptions-text"
								{...{ dataqa: 'settingsInternational-nonDeliveryOptions-text' }}
							>
								Non-Delivery Options:
							</div>
							<WrappedDropdown
								name="customsNonDelivery"
								value={customsNonDelivery}
								onChange={this.onChangeDropdown}
								options={NonDeliveryOptions}
								optionLabel="label"
								optionValue="value"
								dataqa="settingsInternational-nonDeliveryOptions"
							/>
						</div>
						<div className="p-col-10 p-offset-1">
							<div
								className="settings-label"
								data-qa="settingsInternational-customsDeclaration-text"
								{...{ dataqa: 'settingsInternational-customsDeclaration-text' }}
							>
								Customs Declarations:
							</div>
							<WrappedDropdown
								name="createCustomsItems"
								value={createCustomsItems}
								onChange={this.onChangeDropdown}
								options={CustomsDeclarationsOptions}
								optionLabel="label"
								optionValue="value"
								dataqa="settingsInternational-customsDeclaration"
							/>
						</div>

						{displayAdditionalFields && this.renderAdditionalFields()}

						<div className="p-col-10 p-offset-1">
							<div
								className="settings-label"
								data-qa="settingsInternational-itnHeader-text"
								{...{ dataqa: 'settingsInternational-itnHeader-text' }}
							>
								ITN#:
							</div>
							<WrappedInputText
								name="iTNTaxId"
								onChange={this.onChangeField}
								value={iTNTaxId}
								placeholder="Encrypted"
								dataqa="settingsInternational-itnHeader"
							/>
						</div>
						<div className="p-col-10 p-offset-1">
							<div
								className="settings-label"
								data-qa="settingsInternational-whenToIncludeItn-text"
								{...{ dataqa: 'settingsInternational-whenToIncludeItn-text' }}
							>
								When to include ITN#:
							</div>
							<WrappedDropdown
								name="iTNSetting"
								value={iTNSetting}
								onChange={this.onChangeDropdown}
								options={IncludeItnNumberOptions}
								optionLabel="label"
								optionValue="value"
								dataqa="settingsInternational-whenToIncludeItn"
							/>
						</div>
						<div className="p-col-10 p-offset-1">
							<div className="itn-note">
								<p>
									<b>Note: </b>We hide your ITN# on this page after it's saved.
									It will still display on appropriate orders as they import.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="settings-content-footer">
					<WrappedButton
						className="settings-button"
						label="Done"
						type="button"
						onClick={this.onClickDone}
						dataqa="savesettings"
					/>
				</div>
			</div>
		);
	}
}

InternationalView.contextType = ModalContext;
